export var expandTrack = function (channelId) { return function (trackId) {
    return function (dispatch) {
        dispatch({
            type: 'TRACK_EXPANDED',
            payload: {
                trackId: trackId,
                channelId: channelId,
            },
        });
    };
}; };
export var collapseTrack = function (channelId) { return function (trackId) {
    return function (dispatch) {
        dispatch({
            type: 'TRACK_COLLAPSED',
            payload: {
                trackId: trackId,
                channelId: channelId,
            },
        });
    };
}; };



//////////////////
// WEBPACK FOOTER
// ./src/store/actions/activity.actions.ts
// module id = 1430
// module chunks = 81